import axios from './../axios';

export const saveBookmark = async (payload) => {
  try {
    const res = await axios.post(`bookmarks`, payload);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const getBookmarks = async (buyerId) => {
  try {
    const res = await axios.get(`bookmarks?buyer_id=${buyerId}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};

export const deleteBookmark = async (productId) => {
  try {
    const res = await axios.delete(`bookmarks?product_id=${productId}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};
